import { iframeStep } from './iframeStep';
import { infoStep } from './infoStep';

export const circulation = {
  namespaced: true,
  modules: {
    iframeStep,
    infoStep
  }
};
